export default __webpack_public_path__ + "static/media/The Betrayal.ef088482.png";